import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IGetAllTaxonomyPayload, INewTaxonomyData, IOptions, ITaxonomyDetails, ITaxonomyState } from "../models/interfaces";

const initialState: ITaxonomyState = {
	allTaxonomyData: null, // Or provide a default value if needed
	taxonomyDetails: null,
	originalTaxonomyDetails: null,
	isEditIconClicked: false,
	activeTaxonomy: null,
	isEditable: false,
	error: false,
	loading: true,
	openDrawer: false,
	newTaxonomyData: { _id: "", name: "", description: "" },
	taxonomyTags: [],
	showActionsOnEdit: false,
	showEditedStyle: false,
};

const taxonomySlice = createSlice({
	name: "taxonomySlice",
	initialState,
	reducers: {
		setAllTaxonomyData: (state, action: PayloadAction<IGetAllTaxonomyPayload[]>) => {
			state.allTaxonomyData = action.payload;
		},
		setTaxonomyDetails: (state, action: PayloadAction<ITaxonomyDetails>) => {
			state.taxonomyDetails = action.payload;
			state.originalTaxonomyDetails = action.payload;
		},
		setActiveTaxonomy: (state, action: PayloadAction<string>) => {
			state.activeTaxonomy = action.payload;
		},
		setTaxonomyEditable: (state, action: PayloadAction<boolean>) => {
			state.isEditable = action.payload;
		},
		setError: (state, action: PayloadAction<boolean>) => {
			state.error = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setOpenDrawer: (state, action: PayloadAction<boolean>) => {
			state.openDrawer = action.payload;
		},
		setNewTaxonomyData: (state, action: PayloadAction<INewTaxonomyData>) => {
			state.newTaxonomyData = action.payload;
		},
		updateTaxonomyDetails: (state, action: PayloadAction<ITaxonomyDetails>) => {
			state.taxonomyDetails = action.payload;
		},
		addTaxonomyTags: (state, action: PayloadAction<IOptions[]>) => {
			state.taxonomyTags = action.payload;
		},
		updateTaxonomyIsEnabled: (state, action: PayloadAction<boolean>) => {
			state.taxonomyDetails = { ...state.taxonomyDetails, is_enabled: action.payload };
		},
		setIsEditIconClicked: (state, action: PayloadAction<boolean>) => {
			state.isEditIconClicked = action.payload;
		},
		setShowActionsOnEdit: (state, action: PayloadAction<boolean>) => {
			state.showActionsOnEdit = action.payload;
		},
		setShowEditedStyle: (state, action: PayloadAction<boolean>) => {
			state.showEditedStyle = action.payload;
		},
	},
});

export const {
	setAllTaxonomyData,
	setTaxonomyDetails,
	setActiveTaxonomy,
	setTaxonomyEditable,
	setError,
	setLoading,
	setOpenDrawer,
	setNewTaxonomyData,
	updateTaxonomyDetails,
	addTaxonomyTags,
	updateTaxonomyIsEnabled,
	setIsEditIconClicked,
	setShowActionsOnEdit,
	setShowEditedStyle,
} = taxonomySlice.actions;

export default taxonomySlice.reducer;
